import Workchat, { workchatGo } from '@/shared/api/workchat';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export type AuthenticateWorkchatResponse = {
  identity: number;
  token: string;
};

export const authenticateWorkchat = createWiwAsyncThunk<AuthenticateWorkchatResponse, { v2: boolean } | undefined>(
  'workchatv2/auth',
  async (options = { v2: false }, { rejectWithValue }) => {
    const apiTarget = options.v2 ? workchatGo : Workchat;

    try {
      return await apiTarget.url('/token').post(JSON.stringify({ device: 'browser' }));
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
